var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassarPaginaVersaoEsquerdaEscura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-179.999936 11.5 11.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0, 0, 0, 0)",
    fillRule: "evenodd",
    d: "M11.5 0C17.84702278 0 23 5.15297722 23 11.5S17.84702278 23 11.5 23 0 17.84702278 0 11.5 5.15297722 0 11.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    d: "M10.31376518 5.5L8.97058824 6.91l4.36294355 4.59-4.36294355 4.59 1.34317694 1.41 5.71564658-6-5.71564658-6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassarPaginaVersaoEsquerdaEscura);
export default __webpack_public_path__ + "static/media/passar_pagina_versao_esquerda_escura.e89b7fd4d624e56d31d350b185c74f8a.svg";
export { ForwardRef as ReactComponent };